// import Layout from '../Layout'
const Layout = () => import(/* webpackChunkName: "group-logout" */ '../Layout.vue')

export default [
  {
    path: "/logout",
    name: "logout",
    component: Layout
  }
];
